import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEn from "../assets/locales/en.json";
import translationIt from "../assets/locales/it.json";
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    resources: {
      en: {
        translation: translationEn,
      },
      it: {
        translation: translationIt,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });
